import { FieldDefinition } from "./fieldDefinitions";

export interface PatientMedicineDto {
  prescriptionId: number;
  patientId: number;
  medicineId: number;
  doseId: number;
  datePrescribed: string;
  patMedRemarks?: string | null;
  duration?: string | null;
  active: boolean;
  name: string;
  company?: string | null;
  activeIngredient?: string | null;
}

export interface MedicineOption {
  medicineId: number;
  idDescr: string;
}

export const getMedicineOptions = (medicines: Array<MedicineOption> = []) =>
  medicines.map((med) => ({
    label: med.idDescr ?? "Χωρίς περιγραφή",
    value: med.medicineId,
  }));

export const patientMedicineFormData: string[] = [
  "patientId",
  "medicineId",
  "doseId",
  "datePrescribed",
  "patMedRemarks",
  "duration",
  "active",
  "name",
  "company",
  "activeIngredient",
];

export const patientMedicineKeyId = "prescriptionId" as const;

export const getPatientMedicineFields = (
  options: Array<{ value: string | number; label: string }> = [],
): FieldDefinition[] => [
  {
    name: "medicineId",
    label: "Όνομα Φαρμάκου",
    type: "select",
    required: true,
    options,
  },
  {
    name: "datePrescribed",
    label: "Ημερομηνία Συνταγογράφησης",
    type: "date",
    required: true,
  },
  { name: "duration", label: "Διάρκεια", type: "text", required: false },
  {
    name: "patMedRemarks",
    label: "Παρατηρήσεις Συνταγής",
    type: "text",
    required: false,
  },
];

export const patientMedicineFields = getPatientMedicineFields();

export const patientMedicineFilters = patientMedicineFields.filter((f) =>
  ["medicineId", "datePrescribed"].includes(f.name),
);
